import { render } from "./Home.vue?vue&type=template&id=b3cb53c8"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=b3cb53c8&lang=css"

import exportComponent from "/codebuild/output/src515844760/src/osteopath-uk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__